export const visit = (vm, at) => {
at({ "es-mx": { "conversations-message-history": { "status": { "closed": "Esta cadena fue cerrada el {{ dateString }}", "restore": "Restaurar este mensaje", "publishing": { "UNPUBLISHED": "Enviando...", "PUBLISH_FAILED": "No entregada. Haz clic para volver a intentar." } } } } });
};